import styled from 'styled-components';
import { Card, Divider } from 'antd';

export const ContainerCard = styled(Card)`
  &&& {
    background-color: ${(props) => {
    if (props.styleConfig && !props.styleConfig.alternatingBg) return props.theme.backgroundColor.layoutLight;

    return (props.cardParity % 2) === 0
      ? props.theme.backgroundColor.cardDark : props.theme.backgroundColor.layoutLight;
  }};
    margin-bottom: 1rem;
    border: red;
    .ant-card-body {
      padding-top: 0;
      padding-bottom: 0;
      padding-left: ${props => (props.styleConfig && props.styleConfig.cardPadding === true ? '20px' : '0px')};
      padding-right:${props => (props.styleConfig && props.styleConfig.cardPadding === true ? '20px' : '0px')}; 
    }
  }
`;

export const FlowCardGrid = styled(Card.Grid)`
  &&& {
    box-shadow: none;
    display: inline-block;
    vertical-align: top;
    float: none;
    padding-left: ${(props) => {
      return ((props.gridIndex % 2) === 0 && props.gridIndex !== 0) ? "24px" : "0px";
    }};
    padding-right: ${props => (props.cardDetail && props.cardDetail.pright ? '0px' : '0rem')};
    padding-top: ${props => (props.cardDetail && props.cardDetail.ptop ? '1rem' : '0rem')};
    padding-bottom: ${props => (props.cardDetail && props.cardDetail.pbottom ? '1rem' : '0rem')};
    overflow-wrap: break-word;
    box-shadow: ${props => (props.borderNone ? 'none' : 'inset 0 6px 4px -7px #9b9b9b')}
  }
`;

export const DarkerDivider = styled(Divider)`
  border-bottom: 2px solid #9b9b9b;
`;